import PropTypes from 'prop-types';
import { toast } from 'sonner';
import { useTranslation } from 'react-i18next';
import Button from 'Components/Atoms/Button/Button';
import Icon from 'Components/Atoms/Icon/Icon';
import SnackbarCard from './SnackbarCard';

export default function SnackbarInitAsyncProcess({ id, message }) {
    const { t } = useTranslation('common');

    return (
        <SnackbarCard>
            <div className="flex items-center gap-3">
                <div className="shrink-0">
                    <div className="bg-success text-white size-6 rounded-full flex items-center justify-center">
                        <Icon name="check" size={12} color="currentColor" />
                    </div>
                </div>
                <div className="grow max-w-xs">
                    <div className="text-2xs uppercase tracking-wider text-gray-500 mb-0.5">
                        {t('saved-successfully')}
                    </div>
                    <div className="text-sm font-semibold text-pretty">{message}</div>
                </div>
                <div className="shrink-0">
                    <Button size="small" variant="primary" onClick={() => toast.dismiss(id)}>
                        {t('accept')}
                    </Button>
                </div>
            </div>
        </SnackbarCard>
    );
}

SnackbarInitAsyncProcess.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    message: PropTypes.string.isRequired,
};
